# Kept off FullWorkspaceFragment: bootstrap must not depend on a field the
# API may not serve yet, and the field is admin/power-only.
query getWorkspaceWorkforceGuardrails($id: ID!) {
  workspace: getWorkspace(id: $id) {
    id
    config {
      workforceGuardrails
    }
  }
}

mutation updateWorkspaceWorkforceGuardrails(
  $id: ID!
  $workforceGuardrails: JSON!
  $contentHash: String!
) {
  result: updateWorkspaceWorkforceGuardrails(
    id: $id
    workforceGuardrails: $workforceGuardrails
    contentHash: $contentHash
  ) {
    contentHash
    workforceGuardrails
    walkError
  }
}
